module.exports = __webpack_public_path__ + "static/vid2-d52710c73edf95673afd49fbb31fb2be.mp4";